import { getYesOrNoOptions, isYes } from 'helpers';
import { useTranslation } from 'libs/i18n';

import {
  Field,
  useFormContext,
  maxLengthTextField,
} from '../../../forms/companyGlobalFinancialMonitoringPartTwoForm';

import { FieldLabelWithHint } from './components';

export interface FormContentProps {}

export const FormContent = () => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  return (
    <>
      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasSourceOfFundsProcedures.label'
        )}
        name="hasSourceOfFundsProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={
          <FieldLabelWithHint
            hintTexts={t(
              'onboarding.companyGlobalFinancialMonitoring.partTwo.hasRelationshipsWithPEPProcedures.hint.texts',
              { returnObjects: true }
            )}
            hintTitle={t(
              'onboarding.companyGlobalFinancialMonitoring.partTwo.hasRelationshipsWithPEPProcedures.hint.title'
            )}
            label={t(
              'onboarding.companyGlobalFinancialMonitoring.partTwo.hasRelationshipsWithPEPProcedures.label'
            )}
          />
        }
        name="hasRelationshipsWithPEPProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasAnonymousAccounts.label'
        )}
        name="hasAnonymousAccounts"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasAnonymousAccountPreventionProcedures.label'
        )}
        name="hasAnonymousAccountPreventionProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasTransactionMonitoringProcedures.label'
        )}
        name="hasTransactionMonitoringProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasAssetFreezingProcedures.label'
        )}
        name="hasAssetFreezingProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasAMLTrainingProcedures.label'
        )}
        name="hasAMLTrainingProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />
      {isYes(values.hasAMLTrainingProcedures) && (
        <Field.Text
          label={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.amlTrainingDetails.label'
          )}
          maxLength={maxLengthTextField}
          name="amlTrainingDetails"
          placeholder={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.amlTrainingDetails.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasBranchesInNonFATFCountries.label'
        )}
        name="hasBranchesInNonFATFCountries"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      {isYes(values.hasBranchesInNonFATFCountries) && (
        <Field.Text
          label={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.nonFATFBranchesNamesAndLocations.label'
          )}
          maxLength={maxLengthTextField}
          name="nonFATFBranchesNamesAndLocations"
          placeholder={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.nonFATFBranchesNamesAndLocations.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasCorrespondentsInNonFATFCountries.label'
        )}
        name="hasCorrespondentsInNonFATFCountries"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      {isYes(values.hasCorrespondentsInNonFATFCountries) && (
        <Field.Text
          label={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.nonFATFCorrespondentsNames.label'
          )}
          maxLength={maxLengthTextField}
          name="nonFATFCorrespondentsNames"
          placeholder={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.nonFATFCorrespondentsNames.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasCorrespondentsInOffshoreZones.label'
        )}
        name="hasCorrespondentsInOffshoreZones"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      {isYes(values.hasCorrespondentsInOffshoreZones) && (
        <Field.Text
          label={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.offshoreCorrespondentsNames.label'
          )}
          maxLength={maxLengthTextField}
          name="offshoreCorrespondentsNames"
          placeholder={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.offshoreCorrespondentsNames.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasShellBankRelationships.label'
        )}
        name="hasShellBankRelationships"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />
      {isYes(values.hasShellBankRelationships) && (
        <Field.Text
          label={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.shellBanksNames.label'
          )}
          maxLength={maxLengthTextField}
          name="shellBanksNames"
          placeholder={t(
            'onboarding.companyGlobalFinancialMonitoring.partTwo.shellBanksNames.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasShellBankPreventionProcedures.label'
        )}
        name="hasShellBankPreventionProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasCDDRequestComplianceProcedures.label'
        )}
        name="hasCDDRequestComplianceProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Text
        showOptionalMark
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.creditRating.label'
        )}
        maxLength={maxLengthTextField}
        name="creditRating"
        placeholder={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.creditRating.placeholder'
        )}
      />

      <Field.Text
        showOptionalMark
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.subsidiariesNamesAndLocations.label'
        )}
        maxLength={maxLengthTextField}
        name="subsidiariesNamesAndLocations"
        placeholder={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.subsidiariesNamesAndLocations.placeholder'
        )}
      />

      <Field.Text
        showOptionalMark
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.keyPartnersNames.label'
        )}
        maxLength={maxLengthTextField}
        name="keyPartnersNames"
        placeholder={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.keyPartnersNames.placeholder'
        )}
      />

      <Field.Text
        showOptionalMark
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.foreignBranchesNamesAndLocations.label'
        )}
        maxLength={maxLengthTextField}
        name="foreignBranchesNamesAndLocations"
        placeholder={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.foreignBranchesNamesAndLocations.placeholder'
        )}
      />

      <Field.Text
        showOptionalMark
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.financialGroupInfo.label'
        )}
        maxLength={maxLengthTextField}
        name="financialGroupInfo"
        placeholder={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.financialGroupInfo.placeholder'
        )}
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasSanctionPolicyDocuments.label'
        )}
        name="hasSanctionPolicyDocuments"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.hasSanctionsMonitoringProcedures.label'
        )}
        name="hasSanctionsMonitoringProcedures"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.isUnderSanctionsOrControlledBySanctionedEntity.label'
        )}
        name="isUnderSanctionsOrControlledBySanctionedEntity"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.isListedInSanctionLists.label'
        )}
        name="isListedInSanctionLists"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />

      <Field.Autocomplete
        label={t(
          'onboarding.companyGlobalFinancialMonitoring.partTwo.isLinkedToSanctionedEntities.label'
        )}
        name="isLinkedToSanctionedEntities"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.select.placeholder')}
        variant="select"
      />
    </>
  );
};
